"use client";
import React, {
  createContext,
  useState,
  useContext,
  ReactNode,
  useEffect,
} from "react";

type Cookies = { [key: string]: string };

interface CookiesProviderProps {
  initialCookies: Cookies;
  children: ReactNode;
}

const CookiesContext = createContext<Cookies>({});

export const CookiesProvider: React.FC<CookiesProviderProps> = ({
  initialCookies,
  children,
}) => {
  const [cookies, setCookies] = useState<Cookies>(initialCookies);

  useEffect(() => {
    setCookies(initialCookies);
  }, [initialCookies]);

  return (
    <CookiesContext.Provider value={cookies}>
      {children}
    </CookiesContext.Provider>
  );
};

export function useCookies() {
  return useContext(CookiesContext);
}
